import Heading from 'LearningManager/components/Heading';
import { options } from 'LearningManager/constants/createAssignment.constant';
import styles from 'LearningManager/styles/CustomSetup.module.scss';

import { FC, useMemo } from 'react';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import OptionCard from 'LearningManager/components/OptionCard';

const AssignUsers: FC = () => {
	const {
		draft: {
			customSetup: { selectedAssignUsersOptionId }
		},
		setSelectedAssignUsersOptionId
	} = useStepper();

	const SelectedComponent = useMemo(() => {
		const selectedOption = options.find(
			(item) => item.id === selectedAssignUsersOptionId
		);
		return selectedOption?.component || null;
	}, [selectedAssignUsersOptionId]);

	return (
		<div id="lms-ca-assign-users" className={styles['assign-users']}>
			<Heading
				title="Assign Learners"
				subHeading="Select the users who will take this training"
			/>
			<div className={styles.selection}>
				<div className={styles['selection--heading']}>
					Selection Method <span className={styles.star}>*</span>
				</div>
				<div
					id="lms-ca-assign-users-methods"
					className={styles.methods}
				>
					{options.map((opt) => (
						<OptionCard
							key={opt.id}
							htmlId={`lms-ca-assign-users-method-${opt.id}`}
							selectedId={selectedAssignUsersOptionId}
							toggleSelect={setSelectedAssignUsersOptionId}
							{...opt}
						/>
					))}
				</div>
				{SelectedComponent}
			</div>
		</div>
	);
};

export default AssignUsers;
